import { motion } from "framer-motion";
import { CONTENT } from "../data/content";

const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    visible: (delay = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] },
    }),
};

export const About = () => (
    <section id="about" className="px-6 py-28 md:px-12 md:py-40" data-testid="about-section">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-8">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-100px" }}
                custom={0}
                className="md:col-span-5"
            >
                <div className="relative overflow-hidden">
                    <img
                        src={CONTENT.portrait}
                        alt={`${CONTENT.name}, ${CONTENT.role}`}
                        loading="lazy"
                        className="film-frame aspect-[3/4] w-full object-cover object-[62%_40%]"
                        data-testid="about-portrait"
                    />
                    <div className="absolute bottom-0 left-0 bg-[#050505] px-4 py-2 font-body text-[10px] uppercase tracking-[0.35em] text-zinc-400">
                        {CONTENT.location}
                    </div>
                </div>
            </motion.div>

            <div className="md:col-span-6 md:col-start-7 md:pt-16">
                <motion.h2
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    custom={0.1}
                    className="font-display text-6xl leading-none text-white md:text-8xl"
                >
                    About <span className="text-outline">Me</span>
                </motion.h2>
                {CONTENT.bio.map((paragraph, i) => (
                    <motion.p
                        key={i}
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        custom={0.2 + i * 0.1}
                        className="mt-8 max-w-xl font-body text-base font-light leading-relaxed text-zinc-300"
                        data-testid={`bio-paragraph-${i}`}
                    >
                        {paragraph}
                    </motion.p>
                ))}
                <motion.dl
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    custom={0.4}
                    className="mt-14 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-3"
                    data-testid="about-facts"
                >
                    {CONTENT.facts.map((fact) => (
                        <div key={fact.label} className="bg-[#050505] p-6">
                            <dt className="font-body text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                                {fact.label}
                            </dt>
                            <dd className="mt-3 font-display text-3xl text-white">{fact.value}</dd>
                        </div>
                    ))}
                </motion.dl>
            </div>
        </div>
    </section>
);
